import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBack"><Path d="M4 4.75C4 4.33579 4.33579 4 4.75 4C5.16421 4 5.5 4.33579 5.5 4.75V19.25C5.5 19.6642 5.16421 20 4.75 20C4.33579 20 4 19.6642 4 19.25V4.75Z" fill="currentColor"/><Path d="M17.2773 4.29409C18.421 3.53663 20 4.3268 20 5.73504V18.265C20 19.6732 18.421 20.4634 17.2773 19.7059L7.81747 13.4409C6.7811 12.7546 6.7811 11.2454 7.81747 10.5591L17.2773 4.29409Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBack;
